// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2490) return "static/chunks/2490.688ff50c2e4eb9a6.js";
	if (chunkId === 9334) return "static/chunks/9334.e5f25e10d3d66e58.js";
	if (chunkId === 3605) return "static/chunks/3605.3262f0b4de774fcc.js";
	if (chunkId === 8901) return "static/chunks/8901.0814a4a018d606ea.js";
	if (chunkId === 5948) return "static/chunks/5948.e7751ec6f687b4ef.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"881":"5e899c52","1967":"9db8276f","6073":"bdd9618f","7221":"2edd9e6a","9907":"227acf50"}[chunkId] || chunkId) + "-" + {"303":"38943b715f012595","881":"f64d8337dd86126d","1967":"dad51c0337a890ed","4699":"db6be7b8f69a69a3","5961":"2e1fd7fe783e191a","6073":"575abee867aaa421","7221":"1c9b256048e2d20e","9462":"c2815141dfc2821e","9907":"dde7631bc2279a8d"}[chunkId] + ".js";
};